import React, { ChangeEvent, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
} from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import AutoCompleteMultiSelect from "../../../../pages/components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import galleryIcon from "./../../../assets/icons/gallery.png";
import plusIcon from "./../../../assets/icons/plus.png";
import "../AddItem.css";
import { Delete } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import StickyHeadTable from "../../components/SpecificationTable/Specification.tsx";
import Details from "./../../product/components/Details.tsx";
import Story from "./../../product/components/Story.tsx";
import Instructions from "./../../product/components/Instructions.tsx";
import Cancel from "./../../../../assets/icons/close.png";
import DetailsTable from "../../components/SpecificationTable/DetailsTable.tsx";
import SectionTable from "./SectionTable.tsx";
import ChickenIcon from "./../../../../assets/icons/turkey.png";
import ChickenLegIcon from "./../../../../assets/icons/chicken-leg.png";
import Burger1Icon from "./../../../../assets/icons/burger1.png";
import Burger2Icon from "./../../../../assets/icons/burger.png";
import FullPizzaIcon from "./../../../../assets/icons/pizza.png";
import pizzaIcon from "./../../../../assets/icons/pizza (1).png";
import { getMinimalContentHeight } from "@mui/x-data-grid/hooks/features/rows/gridRowsUtils.js";
//import SectionTableSubSection from './SectionTableSubSection.tsx';
//import CustomDialog from '../../components/CustomDialog/CustomDialog.tsx';
//import AddRestaurantDialog from '../../restaurantsetup/components/AddRestaurantDialog/AddRestaurantDialog.tsx';
import itemImg from "./../../../../assets/icons/menu.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import SweetAlertModal from "../../../../pages/components/SweetAlertModal/SweetAlertModal.js";
//import ArchiveDialog from './AddMenu/ArchiveDialog.tsx';
import CustomArchiveDialog from "./AddMenu/CustomArchiveDialog.tsx";

// const imageMap = [
//     { code: 1, icon: ChickenIcon, label: 'Chicken' },
//     { code: 2, icon: ChickenLegIcon, label: 'Chicken' },
//     { code: 3, icon: Burger1Icon, label: 'Chicken' },
//     { code: 4, icon: Burger2Icon, label: 'Chicken' },
//     { code: 5, icon: FullPizzaIcon, label: 'Chicken' },
//     { code: 6, icon: pizzaIcon, label: 'Chicken' },
// ]
const imageSectionMap = [
  { codeSection: 1, icon: ChickenIcon, label: "Chicken" },
  { codeSection: 2, icon: ChickenLegIcon, label: "Chicken" },
  { codeSection: 3, icon: Burger1Icon, label: "Chicken" },
  { codeSection: 4, icon: Burger2Icon, label: "Chicken" },
  { codeSection: 5, icon: FullPizzaIcon, label: "Chicken" },
  { codeSection: 6, icon: pizzaIcon, label: "Chicken" },
];

function AddSubFilterDialog(props) {
  //test start
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [selectedSectionValue, setSelectedSectionValue] = useState<any>(null);
  const [selectedData, setSelectedData] = useState({});
  const [keyword, setKeyword] = useState(null);
  const [imageMap, setimageMap] = useState([]);
  const [typrOfMenuDatas, setTyprOfMenuDatas] = useState([]);
  const [restaurantId, setRestaurantId] = useState([]);
  const apiAddress = process.env.REACT_APP_SECRET;

  // const token = jwt_decode(localStorage.getItem('gotasteadmintoken'));
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);

  const handleAutocompleteChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedValue(value);
  };
  console.log(selectedValue);
  const handleAutocompleteSectionChange = (
    event: ChangeEvent<{}>,
    value: any
  ) => {
    setSelectedSectionValue(value);
  };
  const handleKeyword = (event) => {
    setKeyword(event.target.value);
  };
  const [sectionDatas, setSectionDatas] = useState([]);
  const loadRestaurant = () => {
    axios
      .get(apiAddress + "/api/RestaurantUserMapper/getbyuserid/" + token.UserId)
      .then((response) => {
        console.log(response.data);

        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setSectionDatas(list);
      });
  };

  useEffect(() => {
    loadRestaurant();
    loadRestaurantName();
    console.log("Hit");
    axios.get(apiAddress + "/api/Icon/getallicon").then((response) => {
      console.log(response.data);
      var list = [];
      response.data.map((dt, i) => {
        var obj = { code: dt.id, icon: dt.url, label: dt.name };
        list.push(obj);
      });
      setimageMap(list);
    });
  }, []);

  useEffect(() => {
    axios
      .get(apiAddress + "/api/Menu/GetAllMenuTypeListAsync")
      .then((response) => {
        console.log(response.data);
        var list = [];
        response.data.map((dt, i) => {
          var obj = { id: dt.id, title: dt.typeName };
          list.push(obj);
        });
        setTyprOfMenuDatas(list);
      });
  }, []);

  var obj = {
    Id: "123",
    MenuName: "",
    MenuTypeId: "",
    IconId: "",
    IsActive: true,
    CreationId: "1",
    RestaurantId: [],
  };
  const onClickSave = () => {
    // setSelectedValue(selectedData)
    const Data = {
      Icon: selectedValue,
      Keyword: keyword,
      Section: selectedSectionValue,
    };
    setSelectedData(Data);

    obj.Id = "123";
    obj.MenuName = keyword;
    obj.MenuTypeId = menuType;
    if (selectedValue) {
      obj.IconId = selectedValue.code;
    }

    obj.IsActive = switchCheck;

    restaurantAdded.map((dt, i) => {
      restaurantId.push(dt.id);
    });
    obj.RestaurantId = restaurantId;

    //validation start
    var valid = true;
    if (keyword == undefined) {
      valid = false;
      toast.error("Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else if (selectedValue == null) {
      valid = false;
      toast.error("Icon is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else if (menuType == undefined) {
      valid = false;
      toast.error("Menu type is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // else if (restaurantId.length == 0) {
    //     valid = false
    //     toast.error("Restaurant is required", {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored",
    //     });
    // }
    //validation end

    var url = apiAddress + "/api/Menu";
    // const restaurant = localStorage.getItem('restaurant');
    // var res = JSON.parse(restaurant);
    // console.log(res);
    // obj.RestaurantId.push(res.id);
    const MenuData = obj;
    if (valid) {
      axios.post(url, MenuData).then((response) => {
        console.log(response.data);

        toast.success("successfully submitted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        props.onHandleSelectedData(selectedData);
        props.onHandleAddItem(false);
      });
    }

    setopenConfirmaitonModal(false);
  };

  //test end

  //dialog start
  const [openIconDilaog, setOpenIconDialog] = useState(false);
  const [openArchiveDilaog, setopenArchiveDilaog] = useState(false);
  const [openRestaurantDialog, setRestaurantDialog] = useState(false);

  const handleDialogOpen = (name) => {
    if (name == "icon") {
      setOpenIconDialog(true);
    } else if (name == "restaurant") {
      setRestaurantDialog(true);
    }
  };

  const handleDialog = () => {
    setOpenIconDialog(false);
  };
  const handleAddItem = () => {
    setRestaurantDialog(false);
    setopenArchiveDilaog(false);
  };

  //dialog end

  const handleClose = () => {
    props.onHandleAddItem(false);
    setKeyword(null);
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
  };
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [menuType, setMenuType] = useState();

  const addValue = (props) => {
    setAutoCompleteValue(props);
  };
  const addMenuType = (props) => {
    typrOfMenuDatas.map((data, index) => {
      if (data.title == props) {
        setMenuType(data.id);
      }
    });
  };
  console.log(autoCompleteValue);
  console.log(menuType);
  const renderOption = (option) => (
    <Grid container alignItems="center">
      <Grid item>
        <img src={option.icon} alt="Icon" style={{ width: "1rem" }} />
      </Grid>
      <Grid item>
        <Typography>{option.title}</Typography>
      </Grid>
    </Grid>
  );

  // const getFoodSectionImage = (codeSection) => {
  //     const foundSectionItem = imageSectionMap.find((item) => item.codeSection === codeSection)
  //     if (foundSectionItem) {
  //         return foundSectionItem.icon
  //     }
  //     return null
  // }
  // const getFoodImage = (code) => {

  //     const foundItem = imageMap.find((item) => item.code === code)
  //     if (foundItem) {
  //         return foundItem.icon
  //     }
  //     return null
  // }

  const { open, onClose, dialogType } = props;
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const [userId, setUserId] = useState();
  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestaurantLocaltoken = JSON.parse(localStorage.getItem("restaurant"));
  const token = localStorage.getItem("gotasteadmintoken");

  const [openLeosModal, setopenLeosModal] = useState(false);

  console.log(RestaurantLocaltoken);
  const [restaurantAdded, setRestaurantAdded] = useState([
    { id: RestaurantLocaltoken.id, title: RestaurantLocaltoken.name },
  ]);
  const [tempRestaurantAdded, setTempRestaurantAdded] = useState();
  console.log(restaurantAdded);
  const restaurantAddedvalue = (props) => {
    console.log(props);
    if (props.length > restaurantAdded.length) {
      setRestaurantAdded(props);
      console.log(restaurantAdded);
    } else {
      setopenLeosModal(true);
      setTempRestaurantAdded(props);
    }
  };

  const handleLeosClose = () => {
    console.log(tempRestaurantAdded);
    setRestaurantAdded(tempRestaurantAdded);
    setopenLeosModal(false);
  };

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  const [switchCheck, setswitchCheck] = useState(true);
  const handleSwitchChange = () => {
    if (switchCheck == true) {
      setopenArchiveDilaog(true);
      //setswitchCheck(!switchCheck);
      setIsactiveDialogType("Is Active");
    } else {
      //setopenArchiveDilaog(true);
      handleSwitchToggle();
      //setswitchCheck(!switchCheck);
    }
  };

  const handleSwitchToggle = () => {
    setswitchCheck(!switchCheck);
  };

  // const sectionDatas = [
  //     { id: '1', title: 'Pot Kettle black London' },
  //     { id: '2', title: 'Pot Kettle black Manchester' },
  //     { id: '3', title: 'Pot Kettle black User' }
  // ]
  // const typrOfMenuDatas = [
  //     { id: 2, title: 'Online' },
  //     { id: 3, title: 'Whole sales' },
  //     { id: 4, title: 'Corporate ' },
  //     { id: 4, title: 'Instore ' },

  const [IsactiveDialogType, setIsactiveDialogType] = useState("");

  const deleteBin = () => {
    console.log("Menu Archive");
  };

  // ]
  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={"lg"}
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <ToastContainer></ToastContainer>
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to save this?"}
            open={openConfirmaitonModal}
            onyes={onClickSave}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
          <SweetAlertModal
            headerText={"Do you want delete this?"}
            bodyText={"Are You sure?"}
            open={openLeosModal}
            onyes={handleLeosClose}
            close={() => {
              setopenLeosModal(false);
            }}
            id={2}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>

              {/* {dialogType === 'sub' && <DialogTitle>Sub Menu</DialogTitle>} */}
            </Grid>

            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>

          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>
                    Keyword
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    label="Keyword"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: "#371B17" } }}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>Icon</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Autocomplete
                    id="country-select-demo"
                    // sx={{ width: 300 }}
                    options={imageMap}
                    value={selectedValue}
                    onChange={handleAutocompleteChange}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        <img
                          src={option.icon}
                          alt=""
                          style={{ width: "2rem" }}
                        />
                        {option.label}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select a icon"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password", // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={2} className="AddItemplusIcon" onClick={() => handleDialogOpen('icon')}>
                                    
                                    <button className='modalAddButton'>+Add Icon</button>
                                </Grid> */}
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography>Is Active?</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Switch
                    checked={switchCheck}
                    onChange={handleSwitchChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
              </Grid>
              {/* <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>Restaurant Name</Typography>
                                </Grid>
                                <Grid item xs={8}>

                                    <AutoCompleteMultiSelect
                                        label={'Type Of Restaurant'}
                                        placeholder={'Type Of Restaurant'}
                                        value={addValue}
                                        datas={sectionDatas}
                                    />

                                </Grid>
                                <Grid item xs={2} className="AddItemplusIcon" onClick={() => handleDialogOpen('restaurant')} >
                                    <button className='modalAddButton'>+Add Restaurant</button>
                                </Grid>
                            </Grid> */}

              {/* <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: '1rem' }}>Rank</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextAreaComponents label={'Rank'} />
                </Grid>
              </Grid> */}

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <div className="d-flex justify-content-end">
                    <Button onClick={() => setopenConfirmaitonModal(true)}>
                      Save
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      {/* <CustomDialog
        open={openIconDilaog}
        dialogTitle={'Add Icon'}
        onClose={handleDialog}
      /> */}
      {/* <ArchiveDialog
        open={openArchiveDilaog}
        dialogType={IsactiveDialogType}
        onHandleAddItem={handleAddItem}
        onClose={handleDialog}
        onToggleSwitch={handleSwitchToggle}
      /> */}

      {/* <CustomArchiveDialog
        onClose={handleDialog}
        headerText={"Achive Dialog"}
        bodyText={"This is Menu Archive"}
        open={openArchiveDilaog}
        onyes={deleteBin}
        id={2}
      /> */}
      {/* <AddRestaurantDialog
        open={openRestaurantDialog}
        onHandleAddItem={handleAddItem}
        title={props.title}
      /> */}
    </div>
  );
}

export default AddSubFilterDialog;
